// extracted by mini-css-extract-plugin
module.exports = {"logo":"_02712f2b3b--logo--chwPf","link":"_02712f2b3b--link--MrOJj"};